import { CommonKeys } from '@components/EntityDrawers/constants/keys';
import { ISelectOption } from '@constants/entities/ui';
import { CIASettingsCriteriaType } from '@store/services/questionnaire/types';
import { FieldValues, Path, UseFormSetValue } from 'react-hook-form';

export type CriteriaKey =
  | CommonKeys.Assurance
  | CommonKeys.Coverage
  | CommonKeys.Applicability;

export const getCriteriaPath = (
  criteriaKey: CriteriaKey,
  id: string,
): Path<FieldValues> => `${criteriaKey}.${id}` as Path<FieldValues>;

export const hasSelectedDependencyAnswer = (
  values: ISelectOption[],
  expectedAnswer?: string,
): boolean => values.some(({ value }) => value === expectedAnswer);

export const resetDependentCriteria = (
  fields: CIASettingsCriteriaType[],
  changedId: string,
  values: ISelectOption[],
  criteriaKey: CriteriaKey,
  setValue: UseFormSetValue<FieldValues>,
): void => {
  fields.forEach((field) => {
    if (
      field.dependency?.questionId === changedId &&
      !hasSelectedDependencyAnswer(values, field.dependency?.answer)
    ) {
      setValue(getCriteriaPath(criteriaKey, field.id), [], {
        shouldDirty: true,
        shouldValidate: true,
      });
    }
  });
};
